module.exports = __webpack_public_path__ + "static/media/righthf.f524ce65.png";